import { createContext, ReactNode, useContext, useMemo } from "react";
import { ImageUploadStatus } from "./uploadStatus";

type UploadStatusContextValue = {
  textDocumentId: string;
  getStatus: (uploadId: string) => ImageUploadStatus | undefined;
};

const UploadStatusContext = createContext<UploadStatusContextValue | null>(null);

export const UploadStatusProvider = ({
  textDocumentId,
  statusByUploadId,
  children,
}: {
  textDocumentId: string;
  statusByUploadId: Map<string, ImageUploadStatus>;
  children: ReactNode;
}) => {
  const value = useMemo(
    () => ({ textDocumentId, getStatus: (id: string) => statusByUploadId.get(id) }),
    [textDocumentId, statusByUploadId]
  );
  return <UploadStatusContext.Provider value={value}>{children}</UploadStatusContext.Provider>;
};

export const useUploadStatusContext = (): UploadStatusContextValue | null => useContext(UploadStatusContext);

export const useImageUploadStatus = (uploadId: string | undefined): ImageUploadStatus | undefined => {
  const ctx = useUploadStatusContext();
  return ctx && uploadId ? ctx.getStatus(uploadId) : undefined;
};
